export const title = [
  { id: 1, label: "Your Name", value: "" },
  { id: 2, label: "Your Career", value: "" },
];
